module.exports = __webpack_public_path__ + "static/img/img-popup.2bdd439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/img-popup.jpg
// module id = YRRI
// module chunks = 1